import Controller from '@ember/controller';
import { action } from '@ember/object';

export default class SettingsTagsController extends Controller {
  get themes() {
    return this.model;
  }

  @action
  deleteTheme(theme) {
    theme.destroyRecord();
  }
}
